import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

const INVOICE_PARAM = 'invoice';

export function useInvoiceDrawer() {
  const [searchParams, setSearchParams] = useSearchParams();
  const invoiceId = searchParams.get(INVOICE_PARAM);

  const open = useCallback(
    (id: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set(INVOICE_PARAM, id);
          return next;
        },
        { replace: false },
      );
    },
    [setSearchParams],
  );

  const close = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(INVOICE_PARAM);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return { invoiceId, open, close };
}
